module.exports = __webpack_public_path__ + "static/media/roberto-male-main.1fd569d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Reconstructions/3D/roberto-male-main.jpg
// module id = 479
// module chunks = 0